export const VENUE = {
  name: "Le Château",
  address: "Strada Turturelelor 11, 030881 București, România",
  lat: 44.426765,
  lng: 26.104522,
  placeId: "",
  mapsSearchUrl:
    "https://www.google.com/maps/search/?api=1&query=Le+Ch%C3%A2teau,+Strada+Turturelelor+11,+Bucure%C8%99ti",
  mapsDirectionsUrl:
    "https://www.google.com/maps/dir/?api=1&destination=Le+Ch%C3%A2teau,+Strada+Turturelelor+11,+Bucure%C8%99ti",
};
